import '../../utils/index.mjs';
import TreeV2 from './src/tree.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTreeV2 = withInstall(TreeV2);

export { ElTreeV2, ElTreeV2 as default };
//# sourceMappingURL=index.mjs.map
